const ro = {
  app: {
    title: 'DigestMed Dashboard',
    logoAlt: 'Logo DigestMed',
  },
  header: {
    userMenu: 'Meniu utilizator',
    logout: 'Deconectare',
    language: 'Limbă',
    languageMenu: 'Alegeți limba',
  },
  login: {
    sso: 'Autentificare cu IAM (SSO)',
  },
  period: {
    label: 'Perioadă',
    currentMonth: 'Luna curentă',
    previousMonth: 'Luna precedentă',
    currentQuarter: 'Trimestrul curent',
    yearToDate: 'De la începutul anului',
    last12Months: 'Ultimele 12 luni',
  },
  dashboard: {
    indicators: 'Indicatori',
    loadingValue: 'Se încarcă…',
    noDataYet: 'Încă nu sunt date',
    loadReportsFailed: 'Încărcarea rapoartelor a eșuat',
  },
  reports: {
    tabsLabel: 'Taburi rapoarte',
    viewTab: 'Vizualizare rapoarte',
    auditTab: 'Audit',
    selectReport: 'Selectați raportul',
    view: 'Vizualizare',
    loading: 'Se încarcă…',
    none: 'Nu există rapoarte disponibile.',
    noPathConfigured: 'Raportul selectat nu are o cale configurată.',
    loadFailed: 'Încărcarea rapoartelor a eșuat',
    frameTitle: 'Raport: {{title}}',
  },
  report: {
    fallbackName: 'Raport {{id}}',
    breadcrumb: 'Rapoarte',
    back: 'Înapoi la rapoarte',
    notFound: 'Raportul nu a fost găsit',
    loadError: 'Raportul nu a putut fi încărcat. Încercați din nou mai târziu.',
    viewer: 'Vizualizator raport',
    loadingReport: 'Se încarcă raportul…',
  },
  export: {
    button: 'Export',
    inProgress: 'Se exportă…',
    failed: 'Exportul a eșuat. Încercați din nou.',
    noTables: 'Raportul afișat nu conține tabele de exportat.',
    noCharts: 'Raportul afișat nu conține grafice de exportat.',
    generatedAt: 'Generat: {{date}}',
    periodRange: '{{period}}: {{from}} – {{to}}',
    format: {
      pdf: 'PDF',
      xlsx: 'Excel (XLSX)',
      csv: 'CSV',
      png: 'Grafice PNG',
      pptx: 'Grafice PowerPoint',
    },
    formatHint: {
      pdf: 'Pagina, așa cum este afișată',
      xlsx: 'O foaie pentru fiecare tabel',
      csv: 'Un fișier pentru fiecare tabel',
      png: 'O imagine pentru fiecare grafic',
      pptx: 'Un slide pentru fiecare grafic',
    },
  },
};

export default ro;
